import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { extractMetrics } from '@imaginemos-ae/liveness-ui-component';
import './styles.css';

export function ExtractMetricsWrapper() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const projectName = params.get('projectName') || 'Default';

    return <ExtractMetrics projectName={projectName} />;
}

export default function ExtractMetrics() {
    const [metrics, setMetrics] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Habilitar scroll en body
    useEffect(() => {
        document.body.style.overflow = 'auto';
        document.body.style.position = 'static';
        document.documentElement.style.overflow = 'auto';
        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.documentElement.style.overflow = '';
        };
    }, []);

    const handleExtractMetrics = async () => {
        setLoading(true);
        setError(null);
        
        let stream = null;
        try {
            stream = await navigator.mediaDevices.getUserMedia({ 
                video: { facingMode: 'user', width: { ideal: 1280 }, height: { ideal: 720 } },
                audio: true 
            }).catch(() => 
                navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } })
            );
            
            const result = await extractMetrics(stream, { requireGeolocation: true });
            setMetrics(result);
        } catch (err) {
            setError('Error: ' + err.message);
        } finally {
            // Liberar cámara
            if (stream) {
                stream.getTracks().forEach(track => {
                    track.stop();
                    track.enabled = false;
                });
                stream = null;
            }
            setLoading(false);
        }
    };

    const copyToClipboard = () => {
        if (metrics) {
            navigator.clipboard.writeText(JSON.stringify(metrics, null, 2));
        }
    };

    return (
        <div className="extract-metrics-container">
            <div className="extract-metrics-header">
                <h1>Extraer Métricas del Dispositivo</h1>
                <p>Extrae información del dispositivo sin iniciar el flujo de liveness</p>
            </div>

            <div className="extract-metrics-content">
                <div className="video-section">
                    <button onClick={handleExtractMetrics} disabled={loading} className="btn btn-primary btn-large">
                        {loading ? 'Solicitando permisos...' : 'Extraer Métricas'}
                    </button>
                    <p className="hint">Se solicitarán permisos de cámara, micrófono y ubicación</p>
                </div>

                {error && (
                    <div className="error-message">{error}</div>
                )}

                {metrics && (
                    <div className="metrics-section">
                        <div className="metrics-header">
                            <h2>Métricas Extraídas</h2>
                            <button onClick={copyToClipboard} className="btn btn-small">Copiar JSON</button>
                        </div>
                        
                        <div className="metrics-grid">
                            <MetricCard title="Permisos" data={metrics.permissions} />
                            <MetricCard title="Cámara" data={metrics.camera} />
                            <MetricCard title="Micrófono" data={metrics.microphone} />
                            <MetricCard title="Geolocalización" data={metrics.geolocation} />
                            <MetricCard title="Análisis de Video" data={metrics.videoAnalysis} />
                            <MetricCard title="Dispositivo" data={metrics.device} />
                            <MetricCard title="Dispositivos Disponibles" data={metrics.availableDevices} />
                        </div>

                        <div className="json-output">
                            <h3>JSON Completo</h3>
                            <pre>{JSON.stringify(metrics, null, 2)}</pre>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

function MetricCard({ title, data }) {
    if (!data) return null;
    return (
        <div className="metric-card">
            <h3>{title}</h3>
            <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
    );
}
